export default {"src":"/_next/static/media/3.457b26bf.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};